// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CapacityChip-module__root___QBH15 {
  position: relative;
}

.CapacityChip-module__trigger___EV0eY {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px 2px 4px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  cursor: pointer;
}

.CapacityChip-module__trigger___EV0eY:hover {
  border-color: #9ca3af;
}

.CapacityChip-module__ring___qviyC {
  flex-shrink: 0;
}

.CapacityChip-module__ringTrack___os8gY {
  stroke: #e5e7eb;
}

.CapacityChip-module__ringOk___MGxAv {
  stroke: #374151;
}

.CapacityChip-module__ringOver___vXhtS {
  stroke: #d97706;
}

.CapacityChip-module__ringBreach___EIjpX {
  stroke: #b91c1c;
}

.CapacityChip-module__triggerPct___nAfeH {
  font-family: monospace;
  font-size: 13px;
  font-weight: 600;
}

.CapacityChip-module__textOk____qSsH {
  color: #374151;
}

.CapacityChip-module__textOver___WCXy6 {
  color: #92400e;
}

.CapacityChip-module__textBreach___gRWGu {
  color: #b91c1c;
}

.CapacityChip-module__popover___ABEo_ {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 300px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.16);
  padding: 16px;
  z-index: 1100;
}

.CapacityChip-module__popoverTitle___MgFdp {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 12px;
}

.CapacityChip-module__meterList___UpthE {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.CapacityChip-module__meterRow___EO5cr {
  display: flex;
  flex-direction: column;
}

.CapacityChip-module__meterRowHeader___W5YQ9 {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 4px;
}

.CapacityChip-module__meterLabel___zhviG {
  font-size: 13px;
  color: #4b5563;
}

.CapacityChip-module__meterMeta___j2Io2 {
  font-family: monospace;
  font-size: 10px;
  color: #9ca3af;
}

.CapacityChip-module__barTrack___kmPKL {
  height: 6px;
  background: #f3f4f6;
  border-radius: 3px;
  overflow: hidden;
}

.CapacityChip-module__barOk___JT428 {
  height: 100%;
  background: #374151;
}

.CapacityChip-module__barOver___hRbx0 {
  height: 100%;
  background: #d97706;
}

.CapacityChip-module__barBreach___dtxW5 {
  height: 100%;
  background: #b91c1c;
}

.CapacityChip-module__crunchWrap___qq9IW {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.CapacityChip-module__crunchLine___GRpKF {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.CapacityChip-module__crunchDot___BZDHH {
  width: 6px;
  height: 6px;
  margin-top: 5px;
  border-radius: 999px;
  background: #b91c1c;
  flex-shrink: 0;
}

.CapacityChip-module__crunchTitle___JEeVe {
  font-size: 13px;
  font-weight: 600;
  color: #b91c1c;
}

.CapacityChip-module__crunchText___gPQOu {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.4;
}

.CapacityChip-module__crunchTaskTitle___N17U_ {
  color: #111827;
}

.CapacityChip-module__crunchEmpty___mHxoF {
  font-size: 13px;
  color: #9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/CapacityChip/CapacityChip.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,sBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF","sourcesContent":[".root {\n  position: relative;\n}\n\n.trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 8px 2px 4px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #ffffff;\n  cursor: pointer;\n}\n\n.trigger:hover {\n  border-color: #9ca3af;\n}\n\n.ring {\n  flex-shrink: 0;\n}\n\n.ringTrack {\n  stroke: #e5e7eb;\n}\n\n.ringOk {\n  stroke: #374151;\n}\n\n.ringOver {\n  stroke: #d97706;\n}\n\n.ringBreach {\n  stroke: #b91c1c;\n}\n\n.triggerPct {\n  font-family: monospace;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.textOk {\n  color: #374151;\n}\n\n.textOver {\n  color: #92400e;\n}\n\n.textBreach {\n  color: #b91c1c;\n}\n\n.popover {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 300px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.16);\n  padding: 16px;\n  z-index: 1100;\n}\n\n.popoverTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 12px;\n}\n\n.meterList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.meterRow {\n  display: flex;\n  flex-direction: column;\n}\n\n.meterRowHeader {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.meterLabel {\n  font-size: 13px;\n  color: #4b5563;\n}\n\n.meterMeta {\n  font-family: monospace;\n  font-size: 10px;\n  color: #9ca3af;\n}\n\n.barTrack {\n  height: 6px;\n  background: #f3f4f6;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.barOk {\n  height: 100%;\n  background: #374151;\n}\n\n.barOver {\n  height: 100%;\n  background: #d97706;\n}\n\n.barBreach {\n  height: 100%;\n  background: #b91c1c;\n}\n\n.crunchWrap {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f3f4f6;\n}\n\n.crunchLine {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.crunchDot {\n  width: 6px;\n  height: 6px;\n  margin-top: 5px;\n  border-radius: 999px;\n  background: #b91c1c;\n  flex-shrink: 0;\n}\n\n.crunchTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #b91c1c;\n}\n\n.crunchText {\n  font-size: 13px;\n  color: #4b5563;\n  line-height: 1.4;\n}\n\n.crunchTaskTitle {\n  color: #111827;\n}\n\n.crunchEmpty {\n  font-size: 13px;\n  color: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CapacityChip-module__root___QBH15`,
	"trigger": `CapacityChip-module__trigger___EV0eY`,
	"ring": `CapacityChip-module__ring___qviyC`,
	"ringTrack": `CapacityChip-module__ringTrack___os8gY`,
	"ringOk": `CapacityChip-module__ringOk___MGxAv`,
	"ringOver": `CapacityChip-module__ringOver___vXhtS`,
	"ringBreach": `CapacityChip-module__ringBreach___EIjpX`,
	"triggerPct": `CapacityChip-module__triggerPct___nAfeH`,
	"textOk": `CapacityChip-module__textOk____qSsH`,
	"textOver": `CapacityChip-module__textOver___WCXy6`,
	"textBreach": `CapacityChip-module__textBreach___gRWGu`,
	"popover": `CapacityChip-module__popover___ABEo_`,
	"popoverTitle": `CapacityChip-module__popoverTitle___MgFdp`,
	"meterList": `CapacityChip-module__meterList___UpthE`,
	"meterRow": `CapacityChip-module__meterRow___EO5cr`,
	"meterRowHeader": `CapacityChip-module__meterRowHeader___W5YQ9`,
	"meterLabel": `CapacityChip-module__meterLabel___zhviG`,
	"meterMeta": `CapacityChip-module__meterMeta___j2Io2`,
	"barTrack": `CapacityChip-module__barTrack___kmPKL`,
	"barOk": `CapacityChip-module__barOk___JT428`,
	"barOver": `CapacityChip-module__barOver___hRbx0`,
	"barBreach": `CapacityChip-module__barBreach___dtxW5`,
	"crunchWrap": `CapacityChip-module__crunchWrap___qq9IW`,
	"crunchLine": `CapacityChip-module__crunchLine___GRpKF`,
	"crunchDot": `CapacityChip-module__crunchDot___BZDHH`,
	"crunchTitle": `CapacityChip-module__crunchTitle___JEeVe`,
	"crunchText": `CapacityChip-module__crunchText___gPQOu`,
	"crunchTaskTitle": `CapacityChip-module__crunchTaskTitle___N17U_`,
	"crunchEmpty": `CapacityChip-module__crunchEmpty___mHxoF`
};
module.exports = ___CSS_LOADER_EXPORT___;
